<template>
  <div class="login-body">
    <img class="login-img" src="../assets/login.jpg">
    <div class="login-div">
      <div class="login-title">声呐管理系统</div>
      <el-form ref="form" :model="form" label-width="60px" label-position="top" @keyup.enter.native="login">
        <el-form-item label="用户名称">
          <el-input v-model="form.acct"></el-input>
        </el-form-item>

        <el-form-item label="用户密码" prop="pass">
          <el-input
            type="password"
            v-model="form.pswd"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="login-button-div">
        <el-button type="primary" size="small" v-on:click="login" class="login-button">登录系统</el-button>
      </div>
    </div>
    <div class="login-company">
      @2015-2025 广州市豚奈母婴用品有限公司 版权所有
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        acct: "",
        pswd: "",
      },
    };
  },
  methods: {
    login() {
      let _this = this;

      _this.$http.post(['/user/login', this.form], [function(data) {
        window.sessionStorage.clear();
         _this.$router.push("/");
      }], '.login-div');
    }
    ,authip() {
      let _this = this;
  
      _this.$http.post(['/user/authip', _this.form], [function(data, msg) {
          msg(data)
      }], '.login-div');
    }
  }
};
</script>

<style scoped>
.login-body {
  height: 100%;
  width: 100%;
  overflow: hidden;
  background-color: #e0e0e0;
}
.login-img {
  width: 100%;
  height: 100%;
}
.login-div {
  height: 300px;
  width: 350px;
  padding: 30px;
  position: absolute;
  top: 50%;
  left: 200px;
  background-color: #ffffff;
  transform: translate(0%, -50%);
}

.login-title {
  margin-bottom: 30px;
  text-align: center;
  color: #409eff;
}
.login-button-div {
  text-align: center;
}
.login-company {
  color: #409eff;
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>